import React from "react"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import { Hidden } from "@material-ui/core"
import Image from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

const BioInfoLanding = props => {
  const data = useStaticQuery(graphql`
    query PortImage {
      avatar: file(absolutePath: { regex: "/portfolio-pic.png/" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      site {
        siteMetadata {
          author
        }
      }
    }
  `)
  const { author } = data.site.siteMetadata

  return (
    <React.Fragment>
      <Box
        justifyContent="center"
        display="flex"
        alignItems="center"
        flex={1}
        flexDirection="column"
        minHeight="94vh"
      >
        <Hidden mdDown>
          <Box
            style={{
              backgroundColor: "#FFFF",
              boxShadow:
                "60px 40px 120px 0 rgba(0,0,0,.05), 30px 20px 60px 0 rgba(0,0,0,.05), -25px 0 30px 0 rgba(0,0,0,.02)",
              borderRadius: 500,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 28,
              maxWidth: 280,
              padding: 1,
            }}
          >
            <Image
              fluid={data.avatar.childImageSharp.fluid}
              alt={author}
              style={{ width: 280, margin: 0 }}
              imgStyle={{
                borderRadius: `50%`,
              }}
              title={author}
            />
          </Box>

          <Typography
            variant="h1"
            style={{ fontSize: 56, marginTop: 10, textAlign: "center" }}
          >
            {"SAMEERA MADUSHAN"}
          </Typography>

          <Box
            style={{
              width: 300,
              height: 3,
              backgroundColor: "#fff",
              marginTop: 10,
            }}
          />

          <Typography
            variant="h2"
            style={{ fontSize: 28, marginTop: 20, textAlign: "center" }}
          >
            {"Full Stack Software Engineer"}
          </Typography>
          <Typography
            variant="h2"
            style={{ fontSize: 28, marginTop: 10, textAlign: "center" }}
          >
            {"Web, PWA and Mobile iOS/Android"}
          </Typography>
        </Hidden>

        <Hidden lgUp>
          <Box
            style={{
              backgroundColor: "#FFFF",
              boxShadow:
                "60px 40px 120px 0 rgba(0,0,0,.05), 30px 20px 60px 0 rgba(0,0,0,.05), -25px 0 30px 0 rgba(0,0,0,.02)",
              borderRadius: 500,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 28,
              maxWidth: 200,
              padding: 1,
            }}
          >
            <Image
              fluid={data.avatar.childImageSharp.fluid}
              alt={author}
              style={{ width: 200, margin: 0 }}
              imgStyle={{
                borderRadius: `50%`,
              }}
              title={author}
            />
          </Box>

          <Typography
            variant="h1"
            style={{ fontSize: 30, marginTop: 10, textAlign: "center" }}
          >
            {"SAMEERA MADUSHAN"}
          </Typography>

          <Box
            style={{
              width: 150,
              height: 3,
              backgroundColor: "#e6e6e6",
              marginTop: 10,
            }}
          />

          <Typography
            variant="h2"
            style={{ fontSize: 18, marginTop: 20, textAlign: "center" }}
          >
            {"Full Stack Software Engineer"}
          </Typography>
          <Typography
            variant="h2"
            style={{ fontSize: 18, marginTop: 10, textAlign: "center" }}
          >
            {"Web, PWA and Mobile iOS/Android"}
          </Typography>
        </Hidden>
      </Box>
    </React.Fragment>
  )
}

export default BioInfoLanding
